import { Modal } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as LeftSvg } from '../../assets/svg/left.svg';
import { ReactComponent as LeftWSvg } from '../../assets/svg/left-white.svg';
import { ReactComponent as RightWSvg } from '../../assets/svg/right-white.svg';

import { getAllProjects, getImgUrl, getPredPackage } from '../../api/request';
import { useRoot } from '../../hooks/useRoot.jsx';

const DatabaseWin = ({ show = false, onClose = () => {}}) => {
  const { thirdDB } = useRoot();
  const rightContainer = useRef(null);
  const [dataListByPub, setDataListByPub] = React.useState([]);
  const [rightPage, setRightPage] = useState(1);
  const [rightTotal, setRightTotal] = useState(0);
  const [rightLoading, seRightLoading] = useState(false);

  const leftContainer = useRef(null);
  const [dataList, setDataList] = React.useState([]);
  const [leftPage, setLeftPage] = useState(1);
  const [leftTotal, setLeftTotal] = useState(0);
  const [leftLoading, seLeftLoading] = useState(false);

  const loadMoreByLeft = async () => {
    try {
      seLeftLoading(true);
      if(thirdDB == 'screening') {
        const result = await getPredPackage(false, leftPage);
        if(result.status === 200) {
          const allData = result.data;
          const tempData = [];
          allData.forEach(item => {
            tempData.push({
              projectid: '9999',
              images: [{id: item.id, url: item.ul_design1_variant0 || item.c1_design1_variant0 || item.c2_design1_variant0}]
            });
          });
          setLeftPage(result.current + 1);
          setLeftTotal(result.total);
          setDataList([...dataList, ...tempData]);
        }
      } else {
        const result = await getAllProjects(false, leftPage);
        if(result.status === 200) {
          const allData = result.data;
          const filteredData = allData.filter(item => item.images.length > 0);
          setLeftPage(result.current + 1);
          setLeftTotal(result.total);
          setDataList([...dataList, ...filteredData]);
        }
      }
    } catch(error) {
      // 
    } finally {
      seLeftLoading(false);
    }
  };

  const loadMoreByRight = async () => {
    try {
      seRightLoading(true);
      if(thirdDB == 'screening') {
        const result = await getPredPackage(true, rightPage);
        if(result.status === 200) {
          const allData = result.data;
          const tempData = [];
          allData.forEach(item => {
            tempData.push({
              projectid: '9999',
              images: [{id: item.id, url: item.ul_design1_variant0 || item.c1_design1_variant0 || item.c2_design1_variant0}]
            });
          });
          setRightPage(result.current + 1);
          setRightTotal(result.total);
          setDataListByPub([...dataListByPub, ...tempData]);
        }
      } else {
        const result = await getAllProjects(true, rightPage);
        if(result.status === 200) {
          const allData = result.data;
          const filteredData = allData.filter(item => item.images.length > 0);
          setRightPage(result.current + 1);
          setRightTotal(result.total);
          setDataListByPub([...dataListByPub, ...filteredData]);
        }
      }
    } catch(error) {
      // 
    } finally {
      seRightLoading(false);
    }
  };

  // const getDatabase = useCallback(() => {
  //   const fnTest = async () => {
  //     const result = await getAllProjects();
  //     if(result.status === 200) {
  //       const allData = result.data;
  //       const filteredData = allData.filter(item => item.images.length > 0);
  //       setDataList(filteredData);
  //     }
  //   };
  //   const fnTest2 = async () => {
  //     const result = await getAllProjects(true);
  //     if(result.status === 200) {
  //       const allData = result.data;
  //       const filteredData = allData.filter(item => item.images.length > 0);
  //       setDataListByPub(filteredData);
  //     }
  //   };
  //   fnTest();
  //   fnTest2();
  // }, []);

  // const getScreeningDatabase = useCallback(() => {
  //   const fnTest = async () => {
  //     const result = await getPredPackage();
  //     if(result.status === 200) {
  //       const allData = result.data;
  //       const tempData = [];
  //       allData.forEach(item => {
  //         tempData.push({
  //           projectid: '9999',
  //           images: [{id: item.id, url: item.ul_design1_variant0 || item.c1_design1_variant0 || item.c2_design1_variant0}]
  //         });
  //       });
  //       setDataList(tempData);
  //     }
  //   };
  //   const fnTest2 = async () => {
  //     const result = await getPredPackage(true);
  //     if(result.status === 200) {
  //       const allData = result.data;
  //       const tempData = [];
  //       allData.forEach(item => {
  //         tempData.push({
  //           projectid: '9999',
  //           images: [{id: item.id, url: item.ul_design1_variant0 || item.c1_design1_variant0 || item.c2_design1_variant0}]
  //         });
  //       });
  //       setDataListByPub(tempData);
  //     }
  //   };
  //   fnTest();
  //   fnTest2();
  // }, []);

  // useEffect(() => {
  //   if(show) {
  //     if(thirdDB == 'screening') {
  //       getScreeningDatabase();
  //     } else {
  //       getDatabase();
  //     }
  //   } else {
  //     setDataList([]);
  //     setDataListByPub([]);
  //   }
  // }, [show, thirdDB, getDatabase, getScreeningDatabase]);

  useEffect(() => {
    if(show) {
      loadMoreByRight();
      loadMoreByLeft();
    } else {
      setDataList([]);
      setDataListByPub([]);
      setLeftPage(1);
      setRightPage(1);
      setLeftTotal(0);
      setRightTotal(0);
    }
  }, [show]);

  const fnCloseWin = () => {
    onClose(false);
  };

  const handleScrollByRight = () => {
    const container = rightContainer.current;
    if (!container) return;

    if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10 && !rightLoading && dataListByPub.length < rightTotal) {
      loadMoreByRight();
    }
  };

  const handleScrollByLeft = () => {
    const container = leftContainer.current;
    if (!container) return;

    if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10 && !leftLoading && dataList.length < leftTotal) {
      loadMoreByLeft();
    }
  };

  return <Modal
    open={show}
    closable={false}
    footer={null}
    centered
    width="70%"
    classNames={{
      content: '!p-0 !bg-[#00000082]',
    }}
    onCancel={fnCloseWin}
  >
    <div className='h-[50px] w-full px-[25px] flex justify-start items-center bg-[#013B02]'>
      <LeftSvg onClick={fnCloseWin}></LeftSvg>
      <span onClick={fnCloseWin} className='text-sm font-bold ml-3 cursor-pointer'>Database</span>
    </div>
    <div className='p-4 flex items-center justify-between'>
      <div className='flex-1 bg-black'>
        <div className='h-[50px] w-full px-[35px] flex justify-start items-center bg-[#00A32E] text-white font-bold'>
          My Tests
        </div>
        <div onScroll={handleScrollByLeft} ref={leftContainer} className='overflow-y-auto h-[55vh] py-[20px] pr-[30px]' style={{direction: 'rtl'}}>
          <div className='flex justify-start flex-wrap' style={{direction: 'ltr'}}>
            {
              dataList.map((item, index) => (
                <ImageCom key={index} detail={item}></ImageCom>
              ))
            }
          </div>
        </div>
      </div>
      <div className='w-3 relative'>
        <div className='flex items-center justify-center w-[48px] h-[60px] bg-[#00A32E] rounded ml-[-19px]'>
          <LeftWSvg className="cursor-pointer"></LeftWSvg>
          <div className='w-3'></div>
          <RightWSvg className="cursor-pointer"></RightWSvg>
        </div>
      </div>
      <div className='flex-1 bg-black'>
        <div className='h-[50px] w-full px-[35px] flex justify-start items-center bg-[#00A32E] text-white font-bold'>
          Public
        </div>
        <div onScroll={handleScrollByRight} ref={rightContainer} className='overflow-y-auto h-[55vh] py-[20px] pl-[30px]'>
          <div className='flex justify-start flex-wrap'>
            {
              dataListByPub.map((item, index) => (
                <ImageCom key={index} detail={item}></ImageCom>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  </Modal>;
};

const ImageCom = ({detail}) => {
  const { setOtherProId, setShowDatabaseWin, setCurProId, setStep, thirdDB } = useRoot();
  const { images, projectid } = detail;
  const { id = '', url = '' } = images[0] || {};
  const [ curUrl, setCurUrl ] =  useState('');

  const handleClick = () => {
    if(thirdDB) {
      if(thirdDB === 'screening') {
        setOtherProId(id);
      } else if(thirdDB === 'self') {
        setOtherProId(projectid);
      } 
    } else {
      setCurProId(projectid);
      setStep(3);
    }
    setShowDatabaseWin(false);
  };

  useEffect(() => {
    const fnTest = async() => {
      if(thirdDB === 'screening') {
        if(url) {
          const result = await getImgUrl(url);
          if(result.status === 'Success') {
            setCurUrl(result.data.url);
          }
        }
      } else {
        setCurUrl(url);
      }
    };
    fnTest();
  }, [url, thirdDB]);

  return <div onClick={handleClick} className='relative group overflow-hidden flex flex-col justify-between items-center w-[31%] aspect-[4/5] border border-[#00A32E80] rounded-xl m-[1%]'>
    <div className='p-2 flex-1 h-0 cursor-pointer'>
      <img src={curUrl} className='h-full'></img>
    </div>
    <div className='w-full bg-[#00a0a326] px-2.5 py-1.5 text-[12px] h-[30px]'>
      Pro_img {id}
    </div>
    {/* <DeleteSvg className="absolute top-1.5 right-1.5 hidden group-hover:block fill-[#E83D3D] cursor-pointer"></DeleteSvg> */}
  </div>;
};

export default DatabaseWin;